import React from 'react';
import {
  FilterBox, FilterBoxTitle, FilterItemBox, FilterLineBox,
} from '../style';
import AllFilter from '../utils/ServedFilters/AllFilter';

function WaitTimeFilter({ changeFilter }) {
  return (
    <FilterBox>
      <FilterBoxTitle>Длительность ожидания</FilterBoxTitle>
      <FilterItemBox>
        <FilterLineBox>
          <AllFilter
            changeFilter={changeFilter}
            filld="total_wait_time"
            title="Общая"
            timeFilter="timeFilter"
          />
        </FilterLineBox>
        <FilterLineBox>
          <AllFilter
            changeFilter={changeFilter}
            filld="avg_wait_time"
            title="Средняя"
            timeFilter="timeFilter"
          />
        </FilterLineBox>
      </FilterItemBox>
    </FilterBox>
  );
}
export default WaitTimeFilter;
